import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Navbar       from './components/Navbar';
import Hero         from './components/Hero';
import Stats        from './components/Stats';
import Services     from './components/Services';
import Features     from './components/Features';
import Solutions    from './components/Solutions';
import Process      from './components/Process';
import Testimonials from './components/Testimonials';
import CTA          from './components/CTA';
import Footer       from './components/Footer';
import WaterRippleBackground from './components/WaterRippleBackground';
import ScrollThread from './components/ScrollThread';
import CustomCursor from './components/CustomCursor';
import GlobePreloader from './components/GlobePreloader';

function App() {
  const [introActive, setIntroActive] = useState(true);

  return (
    <div id="app-root">
      <CustomCursor />
      <WaterRippleBackground />
      <ScrollThread />

      <AnimatePresence mode="wait">
        {introActive ? (
          <GlobePreloader key="preloader" onComplete={() => setIntroActive(false)} />
        ) : (
          <motion.div
            key="site-content"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.2, ease: 'easeOut' }}
          >
            <Navbar />
            <main style={{ position: 'relative', zIndex: 1 }}>
              <Hero />
              <Stats />
              <Services />
              <Features />
              <Solutions />
              <Process />
              <Testimonials />
              <CTA />
            </main>
            <Footer />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
